import { DeliveryItems } from '@epicuro-next/state/config-strip-state';
import { Product, ScaleSets } from 'graphql-api/gql-api-interfaces';

export function getMaterialsMatrix(
  availableScaleSets: ScaleSets,
  materials: Product[],
  deliveryItems: DeliveryItems,
  differentMaterialDimensions: boolean,
) {
  const defaultScaleSets =
    availableScaleSets.scales[availableScaleSets.default];
  const [xDimension, yDimension] = Object.keys(defaultScaleSets);
  const materialsMatrix = new Map();

  materials.forEach((material) => {
    if (!material.children) {
      return;
    }
    const yArrayLength = defaultScaleSets[yDimension]?.length ?? 1;

    materialsMatrix.set(material.productId, new Array(yArrayLength));

    material.children.forEach((sizeProduct) => {
      const yPosition = yDimension
        ? getDimensionIndex(
            yDimension,
            sizeProduct,
            availableScaleSets,
            differentMaterialDimensions,
          )
        : 0;
      const xPosition = getDimensionIndex(
        xDimension,
        sizeProduct,
        availableScaleSets,
        differentMaterialDimensions,
      );

      const preFilledQuantity =
        deliveryItems.items[sizeProduct.productId]?.quantity || '';

      if (!materialsMatrix.get(material.productId)[yPosition]) {
        materialsMatrix.get(material.productId)[yPosition] = new Array(
          defaultScaleSets[xDimension].length,
        );
      }

      materialsMatrix.get(material.productId)[yPosition][xPosition] = {
        materialId: material.productId,
        productId: sizeProduct.productId,
        quantity: preFilledQuantity,
        isLocked: Boolean(material.isLocked),
        isConsignmentAvailable: (sizeProduct.inventoryItems || []).some(
          (item) => item.isConsignment,
        ),
        isPreferredNoosWarehouse: (sizeProduct.inventoryItems || []).some(
          (item) => item.isPreferredNoosWarehouse,
        ),
      };
    });
  });

  return materialsMatrix;
}

export function getDimensionIndex(
  dimension: string,
  sizeProduct: Product,
  availableScaleSets: ScaleSets,
  differentMaterialDimensions: boolean,
) {
  const defaultScaleSets =
    availableScaleSets.scales[availableScaleSets.default];
  const dimensionValue = sizeProduct.attributes[dimension] as string;
  const index = defaultScaleSets[dimension].indexOf(dimensionValue);
  // normalizes missing dimensions to be the first row or column
  // differentMaterialDimensions checks the rule if supported
  // dimensionValue should be undefined otherwise it can be defined but without any inventory
  if (
    differentMaterialDimensions &&
    dimensionValue === undefined &&
    index === -1
  )
    return 0;
  return index;
}
